import { Tile, Container, Header, BodyText, Flyer } from "../components/";
import * as React from 'react';

export const Menu = (props) => (
    <div>
    <Header>The Choice is yours 😎</Header>
    <BodyText animation={"fadeIn"}>
      Ready to build a brand that helps you shine in your local market?
      We've put the skills of amazing graphic designers at your
      fingertips, without the need to dish out thousands of dollars.
      Explore our hundreds of templates to find a brand that helps you
      shine. Check back frequently, new designs are always being added.
    </BodyText>
    <Container animation={"fadeIn delay"}>
      <Tile animation={"perkUp"} route={"/marketing/listing"}>
        Create Listing Flyer
      </Tile>
      <Tile animation={"perkUp"} route={"/marketing/route1"}>
        Create Marketing Flyer
      </Tile>
      <Tile animation={"perkUp"} route={"/marketing/route2"}>
        Create Something Flyer
      </Tile>
    </Container>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/marketing/pages/menu.js